import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex w-5/6" }
const _hoisted_2 = { class: "container py-10 mx-auto w-full" }
const _hoisted_3 = { class: "absolute top-0 left-0 text-lg ml-2 flex items-center" }
const _hoisted_4 = { class: "absolute top-0 right-0 text-lg font-semibold mr-2" }
const _hoisted_5 = { class: "lg:flex md:flex-none lg:gap-10 md:gap-0 lg:my-10 md:my-0" }
const _hoisted_6 = { class: "absolute top-0 text-lg left-0 ml-2 flex items-center" }
const _hoisted_7 = { class: "absolute top-0 text-lg right-0 font-semibold mr-2" }
const _hoisted_8 = { class: "absolute top-0 text-lg left-0 ml-2 flex items-center" }
const _hoisted_9 = { class: "absolute top-0 text-lg right-0 font-semibold mr-2" }
const _hoisted_10 = { class: "absolute top-0 text-lg left-0 ml-2 flex items-center" }
const _hoisted_11 = { class: "absolute top-0 text-lg right-0 font-semibold mr-2" }

import {Card, CardContent, CardHeader, CardTitle} from "@/components/ui/card";
  import DashboardDataTable from "@/components/ui_custom/data-table/DashboardDataTable.vue";
  import {onMounted, onUnmounted, ref} from "vue";
  import SharedService from "@/services/shared/shared.service";
  import { buildingColumns } from "@/components/tables/buildings/dashboard-columns"
  import { userColumns } from "@/components/tables/users/dashboard-columns"
  import { masterColumns } from "@/components/tables/masters/dashboard-columns"
  import { managerColumns } from "@/components/tables/managers/dashboard-columns"
  import {User} from "@/models/tables/user.interface";
  import {Building} from "@/models/tables/building.interface";
  import {Master} from "@/models/tables/master.interface";
  import {Manager} from "@/models/tables/manager.interface";
  import { ExternalLink } from "lucide-vue-next";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardView',
  setup(__props) {

  let dashboard: any = ref({});
  let users = ref<User[]>([]);
  let buildings = ref<Building[]>([]);
  let masters = ref<Master[]>([]);
  let managers = ref<Manager[]>([]);



  onMounted(async () => {
    const res = await SharedService.dashboard();
    dashboard.value = res?.data;
    buildings.value = dashboard.value.buildings;
    users.value = dashboard.value.users;
    masters.value = dashboard.value.masters;
    managers.value = dashboard.value.managers;
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Card), { class: "w-full" }, {
        default: _withCtx(() => [
          _createVNode(_unref(CardHeader), {
            class: "relative bg-gray-400 cursor-pointer",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'buildingsTable' })), ["prevent"]))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(CardTitle), null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_unref(ExternalLink), { class: "mr-2 h-5 w-5" }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('menu.buildings')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('dashboard.total')) + ": " + _toDisplayString(_unref(dashboard).buildingsNumber), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(CardContent), null, {
            default: _withCtx(() => [
              _createVNode(DashboardDataTable, {
                data: _unref(buildings),
                columns: _unref(buildingColumns),
                entity: "buildings"
              }, null, 8, ["data", "columns"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(Card), { class: "w-full" }, {
          default: _withCtx(() => [
            _createVNode(_unref(CardHeader), {
              class: "relative bg-gray-400 cursor-pointer",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'managersTable' })), ["prevent"]))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(CardTitle), null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_unref(ExternalLink), { class: "mr-2 h-5 w-5" }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('menu.managers')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('dashboard.total')) + ": " + _toDisplayString(_unref(dashboard).managersNumber), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(CardContent), null, {
              default: _withCtx(() => [
                _createVNode(DashboardDataTable, {
                  data: _unref(managers),
                  columns: _unref(managerColumns),
                  entity: "managers"
                }, null, 8, ["data", "columns"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(Card), { class: "w-full" }, {
          default: _withCtx(() => [
            _createVNode(_unref(CardHeader), {
              class: "relative bg-gray-400 cursor-pointer",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'mastersTable' })), ["prevent"]))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(CardTitle), null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_unref(ExternalLink), { class: "mr-2 h-5 w-5" }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('menu.masters')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('dashboard.total')) + ": " + _toDisplayString(_unref(dashboard).mastersNumber), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(CardContent), null, {
              default: _withCtx(() => [
                _createVNode(DashboardDataTable, {
                  data: _unref(masters),
                  columns: _unref(masterColumns),
                  entity: "masters"
                }, null, 8, ["data", "columns"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode(_unref(Card), { class: "w-full" }, {
        default: _withCtx(() => [
          _createVNode(_unref(CardHeader), {
            class: "relative bg-gray-400 cursor-pointer",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'usersTable' })), ["prevent"]))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(CardTitle), null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_unref(ExternalLink), { class: "mr-2 h-5 w-5" }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('menu.users')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('dashboard.total')) + ": " + _toDisplayString(_unref(dashboard).usersNumber), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(CardContent), null, {
            default: _withCtx(() => [
              _createVNode(DashboardDataTable, {
                data: _unref(users),
                columns: _unref(userColumns),
                entity: "users"
              }, null, 8, ["data", "columns"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})